export default __webpack_public_path__ + "static/media/LogoSunjad-light.0d37f0af.svg";